const CookiePreferences = () => {
  const selector = '#cookie-preferences';

  const openCookiePreferences = (e) => {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
    }

    if (window.Cookiebot && typeof window.Cookiebot.renew === 'function') {
      window.Cookiebot.renew();
      return;
    }

    if (
      window.CookieConsent &&
      typeof window.CookieConsent.renew === 'function'
    ) {
      window.CookieConsent.renew();
    }
  };

  const handleClick = (e) => {
    const link =
      e.target && typeof e.target.closest === 'function'
        ? e.target.closest(selector)
        : null;

    if (!link) {
      return;
    }

    openCookiePreferences(e);
  };

  document.addEventListener('click', handleClick);

  // Optional: allow removing the listener (useful in SPAs)
  return () => document.removeEventListener('click', handleClick);
};

export default CookiePreferences;
